"use client";

import { Dice1, Trophy, Users } from "lucide-react";
import { ChallengeUser } from "@/types/challenges.types";
import { useRouter } from "next/navigation";

interface ActionCardsSectionProps {
  user?: ChallengeUser;
}

export function ActionCardsSection({ user }: ActionCardsSectionProps) {
  const router = useRouter();
  return (
    <section className="py-8 px-4 lg:px-8 flex-grow">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Rhuna Forge Card */}
          <div className="rounded-xl p-8 border border-gray-800/50 flex flex-col justify-between min-h-[200px]" style={{ backgroundColor: '#0C1113' }}>
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(96, 255, 138, 0.1)' }}>
                  <Dice1 className="w-6 h-6" style={{ color: '#60FF8A' }} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">Rhuna Forge</h3>
                  <p className="text-sm" style={{ color: '#99A1AF' }}>Free daily spins</p>
                </div>
              </div>
              <p className="text-sm mb-4" style={{ color: '#99A1AF' }}>Try your luck today and craft amazing items in the Rhuna Forge. Spin the wheel and discover what treasures await!</p>
            </div>
            <button 
              onClick={() => router.push('/daily-lottery')}
              className="w-full text-black font-medium py-3 px-4 rounded-lg transition-colors hover:opacity-80" 
              style={{ backgroundColor: '#60FF8A' }}
            >
              Play Now
            </button>
          </div>

          {/* Leaderboard Card */}
          <div className="rounded-xl p-8 border border-gray-800/50 flex flex-col justify-between min-h-[200px]" style={{ backgroundColor: '#0C1113' }}>
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(252, 200, 0, 0.1)' }}>
                  <Trophy className="w-6 h-6" style={{ color: '#FCC800' }} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">Leaderboard</h3>
                  <p className="text-sm" style={{ color: '#99A1AF' }}>Global rankings</p>
                </div>
              </div>
              <p className="text-sm mb-4" style={{ color: '#99A1AF' }}>
                {user?.rank ? `You're currently ranked #${user.rank.toString()} globally. Compete with other players and climb the ranks to earn recognition and rewards!` : 'Complete quests to appear on the leaderboard and compete with other players worldwide.'}
              </p>
            </div>
            <button 
              onClick={() => router.push('/leaderboard')}
              className="w-full text-black font-medium py-3 px-4 rounded-lg transition-colors hover:opacity-80" 
              style={{ backgroundColor: '#60FF8A' }}
            >
              View Rankings
            </button>
          </div>

          {/* Referrals Card */}
          <div className="rounded-xl p-8 border border-gray-800/50 flex flex-col justify-between min-h-[200px]" style={{ backgroundColor: '#0C1113' }}>
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(30, 41, 59, 0.1)' }}>
                  <Users className="w-6 h-6" style={{ color: '#1E293B' }} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">Referrals</h3>
                  <p className="text-sm" style={{ color: '#99A1AF' }}>50 RPs per referral</p>
                </div>
              </div>
              <p className="text-sm mb-4" style={{ color: '#99A1AF' }}>
                {user?.referralData?.pointsObtained ? 
                  `You've earned ${parseFloat(user.referralData.pointsObtained).toLocaleString()} points from referrals. Keep inviting friends to earn more rewards!` : 
                  'Invite friends to join Rhuna and earn 50 RPs for each successful referral. Share your unique code and start earning today!'
                }
              </p>
            </div>
            <button 
              onClick={() => router.push('/referrals')}
              className="w-full font-medium py-3 px-4 rounded-lg transition-colors hover:opacity-80 border" 
              style={{ backgroundColor: '#0C1113', color: '#D1D5DC', borderColor: '#D1D5DC' }}
            >
              Referral Dashboard
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}